import "../scss/style.scss";
import { CommonFunction } from "./modules/_common";
import { HomeFunction } from "./modules/_home";
import { MediaFunc } from "./modules/_media";

MediaFunc();
HomeFunction();
CommonFunction();
